/**
 * Normalize name/id for user display. Strips a trailing " (id)" from name if present.
 */
export const getUserDisplayParts = (name, id) => {
  let displayName = name != null && String(name).trim() !== "" ? String(name).trim() : "";
  const displayId = id != null && String(id).trim() !== "" ? String(id).trim() : "";

  if (displayName && displayId) {
    const suffix = `(${displayId})`;
    if (displayName.endsWith(suffix)) {
      displayName = displayName.slice(0, -suffix.length).trim();
    }
  }

  return { name: displayName, id: displayId };
};

/**
 * Format a user for single-line display as "User Name (User ID)".
 * Use for titles, disabled inputs, and non-JSX contexts.
 */
export const formatUserNameWithId = (name, id) => {
  const { name: displayName, id: displayId } = getUserDisplayParts(name, id);

  if (!displayName && !displayId) return "---";
  if (!displayName) return displayId;
  if (!displayId) return displayName;

  return `${displayName} (${displayId})`;
};
